module.exports = __webpack_public_path__ + "img/nes.9216ec57.svg";